import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

const VehicleCard = memo(({ vehicle }) => {
  const navigate = useNavigate();

  const handleImageError = (e) => {
    e.target.style.display = 'none';
    e.target.parentElement.innerHTML = '<div class="w-full h-48 flex items-center justify-center text-gray-400 bg-gray-100">Bild nicht verfügbar</div>';
  };

  const handleImageLoad = (e) => {
    e.target.style.opacity = '1';
  };

  return (
    <Card 
      className="hover:shadow-xl transition-shadow cursor-pointer"
      onClick={() => navigate(`/fahrzeug/${vehicle.id}`)}
    >
      <CardHeader>
        {vehicle.image_url && (
          <div className="mb-4 rounded-lg overflow-hidden relative bg-gray-200">
            <img 
              src={vehicle.image_url} 
              alt={vehicle.name}
              loading="lazy"
              decoding="async"
              className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300"
              onLoad={handleImageLoad}
              onError={handleImageError}
              style={{
                minHeight: '12rem',
                opacity: 0,
                transition: 'opacity 0.3s ease-in'
              }}
            />
            {vehicle.additional_images && vehicle.additional_images.length > 0 && (
              <div className="absolute bottom-2 right-2 bg-black/70 text-white px-2 py-1 rounded text-xs">
                +{vehicle.additional_images.length} Bilder
              </div>
            )}
          </div>
        )}
        <CardTitle className="text-2xl text-[#2C3E50]">{vehicle.name}</CardTitle>
        <CardDescription className="text-[#FDB913] font-semibold">
          {vehicle.category}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-gray-600 mb-4 line-clamp-2">{vehicle.description}</p>
        {vehicle.daily_price && (
          <p className="text-lg font-bold text-[#2C3E50]">
            Ab {vehicle.daily_price}€ / Tag
          </p>
        )}
        <Button 
          className="w-full mt-4 bg-[#FDB913] hover:bg-[#F59E0B] text-[#1a1a1a]"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/fahrzeug/${vehicle.id}`);
          }}
        >
          Details ansehen
        </Button>
      </CardContent>
    </Card>
  );
});

VehicleCard.displayName = 'VehicleCard';

export default VehicleCard;
